import mainConfig from './default'

export default {
  ...mainConfig,
  BASE_AUTH_URL: 'https://www.solveigmm.com/ls/api',
  WSS_AUTH_URL: 'www.solveigmm.com/ls/api/ws',
  PRODUCT_NAME: 'html5_video_editor_desktop',
  AUTHORIZATION_REQUIRED: true,
}
